export default __webpack_public_path__ + "static/media/ma.fa3e9960.svg";